import React from "react";
import { Facet } from "./Facet";

export const FacetSection = () => {
  return (
    <div className="facet-section column">
      {/* "commonsource" is the friendly name for each source */}
      <Facet field="commonsource" title="Source" />
    </div>
  );
};
